import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../lib/MobXProvider'
import {WidgetApi} from '../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const TestModeBar = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {testMode} = api.computedConfig
  const showTestModeBar = api.resolveConfigWithSingleResult<boolean>(
    'showTestModeBar',
  )
  const text = api.trans('test_mode_bar.text', {defaultValue: null})

  if (!testMode || !showTestModeBar || !text) {
    return null
  }

  return (
    <div className="test-mode-bar">
      <div className="main">
        <span className="text">{text}</span>
      </div>
    </div>
  )
})
